
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ImageCropperComponent, CropperSettings, Bounds } from "ng2-img-cropper";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from "@ngx-translate/core";
import { FormGroup, FormControl, Validators, FormBuilder } from "@angular/forms";
import { UtilsService } from "app/services/utils.service";
import { HeaderBarLinkResource } from "app/models/HeaderBarLinkResource";
import { HeaderService } from "app/homepage-configuration/header/header.service";
import { HeaderBarLinkListResource } from "app/models/HeaderBarLinkListResource";

@Component({
  selector: 'vbn-header-top-bar',
  templateUrl: './header-top-bar.component.html',
  styleUrls: ['./header-top-bar.component.scss'],
  providers: [HeaderService]
})
export class HeaderTopBarComponent implements OnInit {

  //variables
  selectedOption: boolean = false;
  headerLinkResource: HeaderBarLinkResource;
  headerLinkListResource: HeaderBarLinkListResource;
  showConfirmationLink;
  errorMessage: any;
  showConfirmationText;
  // dateNow: Date;
  // image: any = new Image();

  //link
  // showButtonImageLink: boolean = true;
  // showCropImageLink: boolean = false;
  // croppedImgLink: any;
  // cropperSettingsLink: CropperSettings;
  // isInvalidImgSizeLink: boolean = false;
  // showCropBtnLink: boolean = false;
  // resultImgLink: boolean = false;
  // imageCrtLink: boolean = true;
  saveErrors: boolean = false;
  selected_language: string = "ro";
  saveErrorsUrl: boolean = false;

  //link edit 
  // showButtonImageLinkEdit: boolean = true;
  // showCropImageLinkEdit: boolean = false;
  // croppedImgLinkEdit: any;
  // cropperSettingsLinkEdit: CropperSettings;
  // isInvalidImgSizeLinkEdit: boolean = false;
  // showCropBtnLinkEdit: boolean = false;
  // resultImgLinkEdit: boolean = false;
  // imageCrtLinkEdit: boolean = true;
  // headerTopBarLinkEdit = {
  //   imageString: "",
  //   textRO: "",
  //   textFR: "",
  //   textEN: "",
  //   url: "",
  //   active: "",
  //   openUrlBlank: null,
  //   configurable: null
  // }
  saveErrorsLinkEdit: boolean = false;
  selected_language_link_edit: string = "ro"
  showLinkEdit: boolean = false;
  linkToDelete = null; //: RESURSA
  headerLinkEdit: HeaderBarLinkResource;
  saveErrorsUrlEdit: boolean = false;

  //text
  // showButtonImageText: boolean = true;
  // showCropImageText: boolean = false;
  // croppedImgText: any;
  // cropperSettingsText: CropperSettings;
  // isInvalidImgSizeText: boolean = false;
  // showCropBtnText: boolean = false;
  // resultImgText: boolean = false;
  // imageCrtText: boolean = true;
  headerTopBarText = {
    imageString: "",
    textRO: "",
    textFR: "",
    textEN: "",
    textDE: "",
    active: "",
    openUrlBlank: null
  }
  saveErrorsText: boolean = false;
  selected_language_text: string = "ro"

  // @ViewChild('cropper', undefined) cropper:ImageCropperComponent;
  // @ViewChild('cropper2', undefined) cropper2:ImageCropperComponent;
  // @ViewChild('cropper3', undefined) cropper3:ImageCropperComponent;

  links: any;

  constructor(private translate: TranslateService,
    private _notificationService: NotificationsService,
    private fb: FormBuilder,
    private utilsService: UtilsService,
    private headerService: HeaderService) {
    //link
    // this.cropperSettingsLink = new CropperSettings();
    // this.cropperSettingsLink.compressRatio = 2.125;
    // this.cropperSettingsLink.canvasWidth = 200;
    // this.cropperSettingsLink.canvasHeight = 200;
    // this.cropperSettingsLink.keepAspect = true;
    // this.cropperSettingsLink.croppedWidth = 200;
    // this.cropperSettingsLink.croppedHeight = 200;
    // this.croppedImgLink = {};
    this.headerLinkResource = new HeaderBarLinkResource();
    this.headerLinkListResource = new HeaderBarLinkListResource();
    this.headerLinkResource.openUrlBlank = false;
    this.headerLinkResource.configurable = true;
    //link edit
    // this.cropperSettingsLinkEdit = new CropperSettings();
    // this.cropperSettingsLinkEdit.croppedWidth = 200;
    // this.cropperSettingsLinkEdit.croppedHeight = 200;
    // this.cropperSettingsLinkEdit.compressRatio = 2.125;
    // this.cropperSettingsLinkEdit.canvasWidth = 200;
    // this.cropperSettingsLinkEdit.canvasHeight = 200;
    // this.cropperSettingsLinkEdit.keepAspect = true;
    // this.croppedImgLinkEdit = {};
    // this.headerLinkEdit.openUrlBlank = false;
    //text
    // this.cropperSettingsText = new CropperSettings();
    // this.cropperSettingsText.croppedWidth = 400;
    // this.cropperSettingsText.croppedHeight = 250;
    // this.croppedImgText = {};
    this.headerTopBarText.openUrlBlank = false;
    //general
    // this.dateNow = new Date();
  }

  ngOnInit() {
    this.getAllLinks();
  }

  //link
  // openImageSelectLink() {
  //   this.showButtonImageLink = false;
  //   this.showCropImageLink = true;
  //   this.croppedImgLink = {};
  // }

  // cancelImageLink() {
  //   this.showCropImageLink = false;
  //   this.showButtonImageLink = true;
  // }

  // saveImageCroppedLink(imgCrop) {
  //   if (imgCrop != null && imgCrop != '') {
  //     this.headerTopBarLink.imageString = imgCrop;
  //     this.image.src = "";
  //     this.showCropImageLink = false;
  //     this.imageCrtLink = false;
  //     this.resultImgLink = true;
  //     this.showButtonImageLink = true;
  //     // console.log("---------", this.croppedEditImg)
  //   }
  // }

  // clearLink() {
  //   this.croppedImgLink = {};
  //   this.cropper.reset();
  //   return;
  // }

  getAllLinks() {
    this.headerService.getHeaderBarLinks('/admin/header/barLink/getAll')
      .subscribe(
      body => {
        this.headerLinkListResource = body;
      },
      error => this.errorMessage = <any>error)
  }

  saveLink() {
    this.saveErrors = true;
    let semafor = false;
    if (!this.linkValidator.valid) {
      semafor = true;
      observableForkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields on all languages!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
    if (!this.headerLinkResource.configurable) {
      if (!this.urlValidator.valid) {
        this.saveErrorsUrl = true;
        semafor = true;
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
      }
    }

    if (semafor) {
      return;
    }

    this.headerLinkResource.titleRo = this.utilsService.WhiteSpacesRemover(this.headerLinkResource.titleRo);
    this.headerLinkResource.titleFr = this.utilsService.WhiteSpacesRemover(this.headerLinkResource.titleFr);
    this.headerLinkResource.titleEn = this.utilsService.WhiteSpacesRemover(this.headerLinkResource.titleEn);
    this.headerLinkResource.titleDe = this.utilsService.WhiteSpacesRemover(this.headerLinkResource.titleDe);
    if (!this.headerLinkResource.configurable) {
      this.headerLinkResource.url = this.utilsService.WhiteSpacesRemover(this.headerLinkResource.url);
    }

    this.headerService.saveHeaderBarLink(`/admin/header/barLink/edit`, this.headerLinkResource)
      .subscribe(
      body => {
        this.headerLinkResource = body;
        if (this.headerLinkResource.errorCode == 10088) {
          observableForkJoin(
            this.translate.get('Error'),
            this.translate.get('Only 3 links can be active at the same time!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'error')
          })
        } else {
          this.headerLinkResource = new HeaderBarLinkResource();
          this.headerLinkResource.openUrlBlank = false;
          this.headerLinkResource.configurable = true;
          this.selected_language = "ro";
          this.saveErrors = false;
          this.linkValidator.reset();
          this.urlValidator.reset();
          this.getAllLinks();
          //if(this.headerLinkResource.)
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Content saved with success!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
        }
      },
      error => console.error(error))
  }

  cancelLink() {
    this.headerLinkResource = new HeaderBarLinkResource();
  }

  editLink(links) {
    this.showLinkEdit = true;
    this.headerLinkListResource.headerBarLinkListResource.forEach(function (value) {
      if (links.rid === value.rid) {
        value.showEdit = true;
      }
      else {
        value.showEdit = false;
      }
    });
    this.headerLinkEdit = Object.assign({}, links);
  }

  saveLinkEdit() {
    this.saveErrorsLinkEdit = true;
    let semafor = false;
    if (!this.linkEditValidator.valid) {
      semafor = true;
      observableForkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields on all languages!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      })
    }
    if (!this.headerLinkEdit.configurable) {
      if (!this.urlEditValidator.valid) {
        this.saveErrorsUrlEdit = true;
        semafor = true;
        observableForkJoin(
          this.translate.get('Mising fields'),
          this.translate.get('Please fill out the fields!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'error')
        })
      }
    }

    if (semafor) {
      return;
    }

    this.headerLinkEdit.titleRo = this.utilsService.WhiteSpacesRemover(this.headerLinkEdit.titleRo);
    this.headerLinkEdit.titleFr = this.utilsService.WhiteSpacesRemover(this.headerLinkEdit.titleFr);
    this.headerLinkEdit.titleEn = this.utilsService.WhiteSpacesRemover(this.headerLinkEdit.titleEn);
    this.headerLinkEdit.titleDe = this.utilsService.WhiteSpacesRemover(this.headerLinkEdit.titleDe);
    if (!this.headerLinkEdit.configurable) {
      this.headerLinkEdit.url = this.utilsService.WhiteSpacesRemover(this.headerLinkEdit.url);
    }

    this.headerService.saveHeaderBarLink(`/admin/header/barLink/edit`, this.headerLinkEdit)
      .subscribe(
      body => {
        this.headerLinkEdit = body;
        if (this.headerLinkEdit.errorCode == 10088) {
          observableForkJoin(
            this.translate.get('Error'),
            this.translate.get('Only 3 links can be active at the same time!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'error')
          })
        } else {
          this.linkEditValidator.reset();
          this.urlEditValidator.reset();
          this.getAllLinks();
          observableForkJoin(
            this.translate.get('Success'),
            this.translate.get('Link saved with success!')
          ).subscribe((res) => {
            this._notificationService.create(res[0], res[1], 'success')
          })
        }
      },
      error => console.error(error))
  }

  cancelLinkEdit() {
  }

  setDeletedLink(item) {
    item.showDelete = true;
  }

  deleteLink(rid: number) {
    this.headerService.deleteLink('/admin/header/barLink/delete/' + rid)
      .subscribe(
      response => {
        observableForkJoin(
          this.translate.get('Success'),
          this.translate.get('The link has been successfully deleted!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'success')
        })
        this.getAllLinks();
      },
      error => this.errorMessage = <any>error
      );
  }

  //validatoare
  linkValidator = this.fb.group({
    textRO: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(200), this.utilsService.NoWhitespaceValidator()]],
    textFR: [''],
    textEN: [''],
    textDE: [''],
  })

  urlValidator = this.fb.group({
    url: ['', [Validators.required]]
  })

  linkEditValidator = this.fb.group({
    textRO: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(200), this.utilsService.NoWhitespaceValidator()]],
    textFR: [''],
    textEN: [''],
    textDE: [''],
  })

  urlEditValidator = this.fb.group({
    url: ['', [Validators.required]]
  })

  //link edit
  // openImageSelectLinkEdit() {
  //   this.showButtonImageLinkEdit = false;
  //   this.showCropImageLinkEdit = true;
  //   this.croppedImgLinkEdit = {};
  // }

  // cancelImageLinkEdit() {
  //   this.showCropImageLinkEdit = false;
  //   this.showButtonImageLinkEdit = true;
  // }

  // saveImageCroppedLinkEdit(imgCrop) {
  //   if (imgCrop != null && imgCrop != '') {
  //     this.headerTopBarLinkEdit.imageString = imgCrop;
  //     this.image.src = "";
  //     this.showCropImageLinkEdit = false;
  //     this.imageCrtLinkEdit = false;
  //     this.resultImgLinkEdit = true;
  //     this.showButtonImageLinkEdit = true;
  //     // console.log("---------", this.croppedEditImg)
  //   }
  // }

  // clearLinkEdit() {
  //   this.croppedImgLinkEdit = {};
  //   this.cropper.reset();
  //   return;
  // }

  //text
  // openImageSelectText() {
  //   this.showButtonImageText = false;
  //   this.showCropImageText = true;
  //   this.croppedImgText = {};
  // }

  // cancelImageText() {
  //   this.showCropImageText = false;
  //   this.showButtonImageText = true;
  // }

  // saveImageCroppedText(imgCrop) {
  //   if (imgCrop != null && imgCrop != '') {
  //     this.headerTopBarText.imageString = imgCrop;
  //     this.image.src = "";
  //     this.showCropImageText = false;
  //     this.imageCrtText = false;
  //     this.resultImgText = true;
  //     this.showButtonImageText = true;
  //     // console.log("---------", this.croppedEditImg)
  //   }
  // }

  // saveText(){
  //   this.saveErrorsText = true;
  //   if (!this.textValidator.valid) {
  // 		Observable.forkJoin(
  // 			this.translate.get('Mising fields'),
  // 			this.translate.get('Please fill out the fields on all languages!')
  // 		).subscribe((res) => {
  // 			this._notificationService.create(res[0], res[1], 'error')
  // 		})
  // 		return
  // 	}

  //   this.headerTopBarText.textRO = this.utilsService.WhiteSpacesRemover(this.headerTopBarText.textRO);
  // 	this.headerTopBarText.textFR = this.utilsService.WhiteSpacesRemover(this.headerTopBarText.textFR);
  // 	this.headerTopBarText.textEN = this.utilsService.WhiteSpacesRemover(this.headerTopBarText.textEN);
  // }

  // cancelText(){
  //   this.headerTopBarText = {
  //     imageString: "",
  //     textRO: "",
  //     textFR: "",
  //     textEN: "",
  //     active: "",
  //     openUrlBlank: ""
  //   }
  // }
  // clearText() {
  //   this.croppedImgText = {};
  //   this.cropper.reset();
  //   return;
  // }

  // textValidator = this.fb.group({
  // 	textRO: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(200), this.utilsService.NoWhitespaceValidator()]],
  // 	textFR: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(200), this.utilsService.NoWhitespaceValidator()]],
  // 	textEN: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(200), this.utilsService.NoWhitespaceValidator()]]
  // })

  //general
  // cropped(bounds: Bounds) {
  //   //console.log(bounds);
  //   if(this.isInvalidImgSizeLink){
  //     this.clearLink();
  //   }
  //   if(this.isInvalidImgSizeText){
  //     this.clearText();
  //   }
  //   if(this.isInvalidImgSizeLinkEdit){
  //     this.clearLinkEdit();
  //   }
  // }

  // checkFile(event){
  //   console.log(event)
  //   let file = event.target.files[0];
  //   this.isInvalidImgSizeLink = false;
  //   this.isInvalidImgSizeLinkEdit = false;
  //   this.isInvalidImgSizeText = false;
  //   this.showCropBtnLink = true;
  //   this.showCropBtnText = true;
  //   this.showCropBtnLinkEdit = true;
  //   if (file.type == "image/jpeg" || file.type == "image/JPEG" || file.type == "image/jpg" || file.type == "image/JPG" 
  //         || file.type == "image/png" ||  file.type == "image/PNG" || file.type == "image/gif" || file.type == "image/GIF"
  //         || file.type == "image/bitmap" || file.type == "image/BITMAP" || file.type == "image/tiff" || file.type == "image/TIFF") {
  //           if(file.size > 2000000) {
  //             Observable.forkJoin(
  //               this.translate.get('Error'),
  //               this.translate.get('Maximum size of image is 2 MB!')
  //             ).subscribe((res) => {
  //               this._notificationService.create(res[0], res[1], 'error')
  //             })
  //             event.target.value = "";
  //             console.log(this.cropper.image)
  //             if(event.currentTarget.id == 1){
  //               this.isInvalidImgSizeLink = true;
  //               this.showCropBtnLink = false;
  //             } 
  //             if(event.currentTarget.id == 2){
  //               this.isInvalidImgSizeText = true;
  //               this.showCropBtnText = false;
  //             }
  //             if(event.currentTarget.id == 3){
  //               this.isInvalidImgSizeLinkEdit = true;
  //               this.showCropBtnLinkEdit = false;
  //             }
  //             console.log(event)
  //             return;
  //           } 
  //       console.log()
  //     } else {
  //       Observable.forkJoin(
  //           this.translate.get('Error'),
  //           this.translate.get('Only these formats of image are allowed: JPG, JPEG, PNG, GIF, TIFF, BITMAP!')
  //         ).subscribe((res) => {
  //           this._notificationService.create(res[0], res[1], 'error')
  //         })
  //         return;
  //     }
  // }

}
